import classNames from 'classnames'
import { memo, useCallback } from 'react'
import { FaUserGroup } from 'react-icons/fa6'
import { useShallow } from 'zustand/react/shallow'
import { useGetMyProfileMini } from '../../../../../../hooks/queries/profile/use-get-my-profile-mini'
import { useGlobalStore } from '../../../../../../store/global-store'
import { useGetDataSeats } from '../use-get-data-seats'

export const SelectAll = memo(() => {
  const { streamerId, typeLive, userIdToSendGift, isSelectedAll } =
    useGlobalStore(
      useShallow((state) => ({
        // live: state.live,
        streamerId: state.liveUserId,
        typeLive: state.typeLive,
        userIdToSendGift: state.userIdToSendGift,
        isSelectedAll: state.isSelectedAll,
      })),
    )

  const { user: userGlobal } = useGetMyProfileMini()

  const { dataSeats } = useGetDataSeats()

  const handleSelectAll = useCallback(() => {
    // NUNCA incluir a si mesmo: o backend rejeita o lote inteiro com
    // cannot_gift_yourself. Vale pro host (streamerId === meu id) e pro viewer
    // sentado num seat.
    const myId = Number(userGlobal?.id)
    const notMe = (id: unknown) =>
      id != null && Number.isFinite(Number(id)) && Number(id) !== myId

    if (!typeLive?.includes('multi')) {
      return useGlobalStore.setState(() => {
        const data = new Set<number>()

        if (notMe(streamerId)) data.add(Number(streamerId))
        if (notMe(userIdToSendGift)) data.add(Number(userIdToSendGift))

        return {
          usersToGift: data,
          isSelectedAll: true,
        }
      })
    }

    const newSet = new Set<number>()
    // o host (streamerId) entra na leva de "todos" (a não ser que eu seja o host)
    if (notMe(streamerId)) newSet.add(Number(streamerId))
    dataSeats.forEach((user) => {
      if (notMe(user?.userId)) newSet.add(Number(user?.userId))
    })

    useGlobalStore.setState({ usersToGift: newSet, isSelectedAll: true })
  }, [streamerId, dataSeats, userIdToSendGift, userGlobal?.id, typeLive])

  const handleClearUsersToGift = useCallback(() => {
    useGlobalStore.setState({ isSelectedAll: false })
    useGlobalStore.setState({ usersToGift: new Set() })
  }, [])

  return (
    typeLive?.includes('multi') && (
      <div
        className={classNames(
          'rounded-full flex w-10 h-10 items-center justify-center text-white',
          {
            'border-2 border-purple-600': isSelectedAll,
          },
        )}
        onClick={isSelectedAll ? handleClearUsersToGift : handleSelectAll}
      >
        <FaUserGroup />
      </div>
    )
  )
})
